<template>
  <div id="promoter">
    <DefaultLayout>
      <template v-slot:sidebar>
        <PromotorSidebar />
      </template>
      <template>
        <router-view />
      </template>
    </DefaultLayout>
  </div>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import PromotorSidebar from "@/components/Sidebar/PromotorSidebar.vue";
export default {
  components: {
    DefaultLayout,
    PromotorSidebar,
  },
};
</script>

<style lang="scss" scoped>
</style>